<template>
    <div class="quote-item-form">
        <v-layout row wrap align-start>
            <input type="hidden" name="product_id" v-model="product.product_id">
            <input type="hidden" name="control_voltage" v-model="product.control_voltage">
            <input v-if="!showWidth" type="hidden" name="diameter" v-model="product.diameter">
            <v-flex xs12 md4 sm6 class="pa-2">
                <v-select v-model="product.product_id" :error="hasError('product_id')" :error-messages="errorMsgs('product_id')" validate-on-blur :rules="[rules.required]" messages="Use drop down arrow to select options" label="Product" box required :items="availableProducts" item-text="label" item-value="id"></v-select>
            </v-flex>
            <v-flex xs12 md4 sm6 class="pa-2">
                <v-text-field name="quantity" :error="hasError('quantity')" :error-messages="errorMsgs('quantity')" validate-on-blur :rules="[rules.required,rules.integer]" v-model="product.quantity" type="number" min="0" @wheel="$event.target.blur()" label="Quantity of this size" required box messages="Additional sizes can be added once this item  has been completed"></v-text-field>
            </v-flex>
            <v-flex xs12 md4 sm6 class="pa-2">
                <v-text-field name="tagging" :error="hasError('tagging')" :error-messages="errorMsgs('tagging')" :rules="[rules.max15]" validate-on-blur v-model="product.tagging" box label="Custom Tagging" hint="i.e. EDH-1"></v-text-field>
            </v-flex>
        </v-layout>
        <v-divider color="black"></v-divider>
        <v-layout row wrap align-start pa-2 v-if="product.product_id">
            <v-flex xs12 md4 sm6 class="pa-2">
                <h3 class="mb-2">Duct Dimensions – External</h3>
                <v-text-field v-model="product.width" :error="hasError('width')" :error-messages="errorMsgs('width')" validate-on-blur :rules="[rules.required,rules.number, rules.positive]" name="width" type="number"  @wheel="$event.target.blur()" label="Width (in.)" box required v-if="showWidth" min="0"></v-text-field>
                <v-text-field v-model="product.height" :error="hasError('height')" :error-messages="errorMsgs('height')" validate-on-blur :rules="[rules.required,rules.number, rules.positive]" name=" height" type="number" @wheel="$event.target.blur()" label="Height (in.)" box required v-if="showHeight" min="0"></v-text-field>
                <v-select v-model="product.diameter" :error="hasError('diameter')" :error-messages="errorMsgs('diameter')" validate-on-blur :rules="[rules.required]" label="Diameter (in.)" box required :items="round_duct_options" v-if="showDiameter" min="0"></v-select>
                <v-checkbox v-if="product.product != 'ROUNDF'" v-model="show_recess" label="Do you have internal insulation or double-wall duct?" :off-icon="'far fa-square'">
                    <v-tooltip top slot="append">
                        <v-icon slot="activator" @click="showTip('ddddd')" small>fa-question-circle</v-icon>
                        <span>A recess spacer is implemented to insert the elements past the insulation or double wall. Heater frame is also under-sized in Slip-In mounting applications.</span>
                    </v-tooltip>
                </v-checkbox>
                <v-text-field v-if="show_recess" v-model="product.insulation_thickness" :error="hasError('insulation_thickness')" :error-messages="errorMsgs('insulation_thickness')" validate-on-blur :rules="[rules.number,validate_insulation_thickness, rules.positive]" name="insulation_thickness" type="number" @wheel="$event.target.blur()" label="Insulation Thickness (in.)" box min="0"></v-text-field>
                <!-- <v-btn :color="product.duct_type == 'Rectangular' ? 'red' : ''" block @click="product.duct_type = 'Rectangular'">Rectangular<v-icon v-if="product.duct_type == 'Rectangular'" right>fa-check</v-icon></v-btn>
                <v-btn :color="product.duct_type == 'Round' ? 'red' : ''" block @click="product.duct_type = 'Round'">Round<v-icon v-if="product.duct_type == 'Round'" right>fa-check</v-icon></v-btn>//-->
                <div v-if="showType">
                    <v-radio-group label="Mount Type:" :error="hasError('mount_type')" :error-messages="errorMsgs('mount_type')" validate-on-blur :rules="[rules.required]" required v-model="product.mount_type" name="mount_type" row>
                        <v-radio :off-icon="'far fa-circle'" label="Slip-in" value="S"></v-radio>
                        <v-radio :off-icon="'far fa-circle'" label="Flange" value="F"></v-radio>
                    </v-radio-group>
                </div>
            </v-flex>
            <v-flex xs12 md8 sm6 class="pa-2">
                <div v-if="product.product == 'EDH2'">
                    <strong>E-Series - Flip-Able Duct Heater - Specifically designed, developed and tested with symmetry in mind eliminating the need for right and left handed designs or up and down flow designs.</strong>
                </div>
                <div v-if="product.product == 'ROUNDF'">
                    <strong>R-Series - Round Duct Heater - Designed for round duct applications.</strong>
                </div>
                <div v-if="product.product == 'EVH'">
                    <strong>E-Series - VAV Flip-Able Heater - Designed for VAV single duct applications, can be installed a minimum distance of 20” from the air damper valve.</strong>
                </div>
                <div v-if="product.product == 'EDH2' || product.product == 'A-EDH' || product.product == 'A-DHSPEC'">
                    <img v-if="product.mount_type == 'S'" src="/_assets/images/DuctHeaterType-Render-Rectangular.jpg" class="duct-image">
                    <img v-if="product.mount_type == 'F'" src="/_assets/images/DuctHeaterType-Render-Rectangular-Flange.JPG" class="duct-image">
                </div>
                <div v-if="product.product == 'EVH' || product.product == 'A-EVH'">
                    <img v-if="product.mount_type == 'S'" src="/_assets/images/DuctHeaterType-Render-Rectangular.jpg" class="duct-image">
                    <img v-if="product.mount_type == 'F'" src="/_assets/images/DuctHeaterType-Render-Rectangular-Flange.JPG" class="duct-image">
                </div>
                <div v-if="product.product == 'ROUNDF'">
                    <img src="/_assets/images/DuctHeaterType-Drawings-Round.svg" class="duct-image">
                </div>
            </v-flex>
        </v-layout>
        <v-divider color="black"></v-divider>
        <v-layout row wrap align-start>
            <v-flex xs12 class="pa-2">
                <h3 class="mb-2">General Specifications</h3>
            </v-flex>
            <v-flex xs12 sm6 class="pa-2">
                <input type="hidden" name="voltage_id" :value="product.voltage.id" />
                <v-select v-model="product.voltage" :error="hasError('voltage_id')" :error-messages="errorMsgs('voltage_id')" validate-on-blur :rules="[rules.required_voltage]" :messages="voltage_message" label="Voltage / Phase" box required :items="voltage_items" item-text="label" return-object></v-select>
            </v-flex>
            <v-flex xs12 sm6 class="pa-2">
                <v-text-field v-model="product.kw" :error="hasError('kw')" :error-messages="errorMsgs('kw')" validate-on-blur :rules="[rules.required,rules.number]" name="kw" type="number" min="0" @wheel="$event.target.blur()" label="Kilowatts (kw)" box required></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 class="pa-2">
                <v-text-field v-model="product.stages" :error="hasError('product.stages')" :error-messages="errorMsgs('product.stages')" validate-on-blur :rules="[rules.required,rules.integer,validate_stages]" hint="Number of stages must be set to 1 when selecting SCR control." name="stages" type="number" min="0" @wheel="$event.target.blur()" label="Number of Stages" box required></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 class="pa-2">
                <v-select v-model="product.control_voltage" :error="hasError('product.control_voltage')" :error-messages="errorMsgs('product.control_voltage')" validate-on-blur :rules="[rules.required]" label="Control Voltage" box required :items="control_voltage_items"></v-select>
            </v-flex>
        </v-layout>
        <div v-for="category in categories">
            <v-divider color="black" class="mb-4"></v-divider>
            <v-layout row wrap align-start class="pa-2">
                <v-flex xs12>
                    <h3 class="mb-2">{{ category.label }}</h3>
                </v-flex>
                <div class="accessory_columns">
                    <template v-for="(acc, k) in category_accessories(category.id)">
                        <div :class="[{ 'fade-more' : !show_accessory(acc)}, 'acc_id_' + acc.id]" :key="'acc_' + k">
                            <v-checkbox :ripple="false" :error="hasError(acc.id)" :error-messages="errorMsgs(acc.id)" :disabled="!show_accessory(acc)" :hide-details="!hasError(acc.id)" slot="activator" v-on:click.passive="checkExclusiveOf(acc)" v-model="product.quote_accessories[acc.id]" name="accessories[]" :off-icon="'far fa-square'" :value="1">
                                <template slot="label">
                                    <span v-on:click.passive="checkExclusiveOf(acc)">{{ acc.label }}</span>
                                    <v-tooltip v-if="acc.tooltip" top slot="append">
                                        <v-icon slot="activator" @click="showTip(acc.tooltip)" small>fa-question-circle</v-icon>
                                        <span>{{ acc.tooltip }} - ({{ acc.code }})</span>
                                    </v-tooltip>
                                </template>
                            </v-checkbox>
                        </div>
                    </template>
                    <input v-for="(i, k) in selected_accessories" type="hidden" name="quote_accessories[]" :value="k" />
                </div>
            </v-layout>
        </div>
        <v-layout row wrap align-start class="pa-2">
            <v-flex xs8>
                <v-btn id="form_submit_btn"  @click="$emit('submit') " color="primary" block large>{{ !isNew ? 'Save Changes' : "Add Heater to Quote" }}</v-btn>
            </v-flex>
            <v-flex xs4>
                <v-btn @click="cancel()" block large>Cancel</v-btn>
            </v-flex>
        </v-layout>
    </div>
</template>
<script>
import FieldRules from '../utils/FieldRules'
const request = require('superagent');
//import Options from '../tutco/options';

export default {
    props: ['isNew', 'quoteItem', 'availableProducts', 'quoteId', 'oldForm'],
    data: function() {

        return {
            rules: FieldRules,
            errors: window.errors,
            product: {
                product_id: null,
                product: null,
                tagging: null,
                duct_type: 'Rectangular',
                quantity: 1,
                mount_type: 'S',
                height: null,
                width: null,
                diameter: null,
                kw: null,
                voltage: null,
                phase: null,
                stages: 1,
                control_voltage: 24,
                recess: null,
                insulation_thickness: null,
                quote_accessories: { "15": 1, "13": 1 },
                voltage: {
                    voltage: null,
                    phase: null,
                    frequency: null
                }
            },
            round_duct_options: [{
                    'text': '6"',
                    'value': 6
                },
                {
                    'text': '8"',
                    'value': 8
                },
                {
                    'text': '10"',
                    'value': 10
                },
                {
                    'text': '12"',
                    'value': 12
                }
            ],
            phase_items: [{
                    'text': 'Single Phase',
                    'value': 1
                },
                {
                    'text': '3 Phase',
                    'value': 3
                }
            ],
            round_voltage_exclusions: [
                '110/1/60/L1-N',
                '115/1/60/L1-N',
                '220/1/50/L1-N/Non-US',
                '230/1/50/L1-N/Non-US',
                '240/1/50/L1-N/Non-US',
                '400/3/50/L1-L3,N/Non-US',
                '415/3/50/L1-L3,N/Non-US',
            ],
            categories: [],
            accessories: [],
            voltages: [],
            show_recess: false,
            //accessories_1 : Options.accessories_1,
            //accessories_2 : Options.accessories_2,
            //build_options : Options.build_options,
        }
    },
    mounted() {
        //loadin accessory options
        var g = this;
        request.get('/portal/api/accessory').end((err, res) => {
            if (!res.body) {
                alert("There was a problem getting accessories and build options from the server." + err);
                return;
            }
            g.accessories = res.body.accessories;
            g.categories = res.body.accessory_categories;
            g.voltages = res.body.voltages;
            for (var i = 0; i < g.accessories; i++) {
                g.$set(g.product.quote_accessories, g.accessories[i].id, null);
            }
            this.syncQuoteItemValues();
        });
        this.syncQuoteItemValues();
        if (typeof this.oldForm != 'undefined' && typeof this.oldForm.quote_accessories != 'undefined') {
            for (var i = 0; i < this.oldForm.quote_accessories.length; i++) {
                g.$set(this.product.quote_accessories, this.oldForm.quote_accessories[i], 1);
            }
        } else {
            if (typeof this.quoteItem.accessories != 'undefined') {
                for (var i = 0; i < this.quoteItem.accessories.length; i++) {
                    g.$set(this.product.quote_accessories, this.quoteItem.accessories[i].id, 1);
                }
            }
        }

        if (this.product.insulation_thickness > 0) {
            this.show_recess = true;
        }
        if (typeof this.errors == 'undefined') {
            this.errors = [];
        }
    },
    methods: {
        syncQuoteItemValues: function() {
            if (typeof this.quoteItem != 'undefined') {
                var g = this;
                Object.keys(this.product).forEach(function(k) {
                    if (k == 'product') {
                        //g.product.product_id = g.quoteItem[k].id
                        return;
                    } else if (k == 'voltage') {
                        g.product.voltage = g.findVoltage(g.quoteItem.voltage_id);
                    } else if (k == 'quote_accessories') {
                        for (var i = 0; i < g.accessories.length - 1; i++) {
                            if (typeof g.product.quote_accessories[g.accessories[i].id] == 'undefined') {
                                g.$set(g.product.quote_accessories, g.accessories[i].id, null);
                            }
                        }
                    } else if (typeof g.quoteItem[k] != 'undefined' && g.quoteItem[k] !== null) {
                        g.product[k] = g.quoteItem[k];
                    }
                });
            }
        },
        findVoltage: function(id) {
            for (var i = 0; i < this.voltages.length; i++) {
                if (this.voltages[i].id == id) {
                    this.voltages[i].id
                    return this.voltages[i];
                }
            }
            return this.product.voltage;
        },
        category_accessories: function(id) {
            var r = [];
            for (var i = 0; i < this.accessories.length; i++) {
                if (this.accessories[i].accessory_category_id == id) {
                    r.push(this.accessories[i]);
                }
            }
            return r;
        },
        show_accessory: function(acc) {
            var display = true;
            if (this.product.product == 'ROUNDF' && acc.e_series_only === 1) {
                this.product.quote_accessories[acc.id] = null;
                this.product[acc.key] = null;
                return false;
            }
            if (typeof acc.dependent_on != 'undefined' && acc.dependent_on.length > 0) {
                for (var i = 0; i < acc.dependent_on.length; i++) {
                    if (this.product.quote_accessories[acc.dependent_on[i].id] != 1) {
                        this.product.quote_accessories[acc.id] = null;
                        display = false;
                    }
                }
            }
            if (acc.old_key == 'quote_power_vav') {
                if (this.product.product != 'EVH') {
                    display = false;
                }
            }
            return display;
        },
        getProduct: function(id) {
            for (var i = 0; i < this.availableProducts.length; i++) {
                if (this.availableProducts[i].id == id) {
                    return this.availableProducts[i];
                }
            }
        },
        validate: function() {
            if (this.product.voltage.voltage == null) {
                return false;
            }
            if (!this.validate_insulation_thickness()) {
                return false;
            }
            if (!this.validate_stages()) {
                return false;
            }
            return true;
        },
        validate_insulation_thickness: function() {
            if (this.showWidth) {
                if (Number(this.product.insulation_thickness) >= Number(this.product.width)) {
                    this.$set(this.errors, 'insulation_thickness', 'This number must be less than the width.');
                    return 'This number must be less than the width.';
                }
                delete this.errors.insulation_thickness
                return true;
            } else {
                if (Number(this.product.insulation_thickness) >= Number(this.product.diameter)) {
                    this.$set(this.errors, 'insulation_thickness', 'This number must be less than the diameter.');
                    return 'This number must be less than the diameter.';
                }
                delete this.errors.insulation_thickness
                return true;
            }
        },
        validate_stages: function() {
            if (this.product.quote_accessories[19] == 1 && parseInt(this.product.stages) > 1) {
                this.$set(this.errors, 'stages', 'Only 1 stage is allowed when SCR is selected');
                return 'Only 1 stage is allowed when SCR is selected';
            }
            return true;
        },
        cancel: function() {
            document.location = window.base_url + "/quote/" + this.quoteId;
        },
        hasError: function(key) {
            return (typeof(this.errors) != 'undefined') && (typeof(this.errors[key]) != 'undefined');
        },
        errorMsgs: function(key) {
            if (this.hasError(key)) {
                return this.errors[key];
            }
            return '';
        },
        checkExclusiveOf: function(acc) {
            if (this.product.quote_accessories[acc.id] != 1) {

                for (var i = 0; i < this.accessories.length; i++) {
                    var a = this.accessories[i];
                    for (var o = 0; o < a.exclusive_of.length; o++) {
                        if (a.exclusive_of[o].code == acc.code) {
                            this.$set(this.product.quote_accessories, a.id, null);
                        }
                    }
                    for (var o = 0; o < acc.exclusive_of.length; o++) {
                        if (acc.exclusive_of[o].code == a.code) {
                            this.$set(this.product.quote_accessories, a.id, null);
                        }
                    }
                }
            } else {
                //also check if other items are dependent on this, so we can uncheck them.
                for (var i = 0; i < this.accessories.length; i++) {
                    var a = this.accessories[i];
                    for (var o = 0; o < a.dependent_on.length; o++) {
                        if (a.dependent_on[o].code == acc.code) {
                            this.$set(this.product.quote_accessories, a.id, null);
                        }
                    }
                }
            }


            return false;
        },
    },
    computed: {
        'showHeight': function() {
            return ['EDH2', 'EVH', 'A-EVH', 'A-EDH', 'A-DHSPEC'].includes(this.product.product);
        },
        'showWidth': function() {
            return ['EDH2', 'EVH', 'A-EVH', 'A-EDH', 'A-DHSPEC'].includes(this.product.product);
        },
        'showType': function() {
            return ['EDH2', 'EVH', 'A-EVH', 'A-EDH', 'A-DHSPEC'].includes(this.product.product);
        },
        'showDiameter': function() {
            return this.product.product == 'ROUNDF';
        },
        'control_voltage_items': function() {
            if (this.product.product == 'EDH2' || this.product.product == 'EVH' || this.product.product == 'EDH') {
                return [{
                    'text': '24v',
                    'value': 24
                }]
            } else {
                return [{
                    'text': '24v',
                    'value': 24
                }, {
                    'text': '120v',
                    'value': 120
                }, {
                    'text': '277v',
                    'value': 277
                }, ]
            }
        },
        'selected_accessories': function() {
            var r = {};
            for (var i = 0; i < this.accessories.length; i++) {
                if (this.product.quote_accessories[this.accessories[i].id] == 1) {
                    r[this.accessories[i].id] = 1;
                }
            }
            return r;
        },
        'voltage_message': function() {
            return this.product.voltage.voltage == null || this.product.voltage.voltage == 0 ? '' : this.product.voltage.voltage + 'V ' + this.product.voltage.phase + ' Phase ' + ' ' + this.product.voltage.frequency + 'Hz'
        },
        'voltage_items': function() {
            var v = [];
            v.push({ voltage: 0, id: null, frequency: 50, phase: 0, label: '------------------------------ ' });
            v.push({ voltage: 0, id: null, frequency: 60, phase: 3, label: '------------------------------' });
            for (var i = 0; i < this.voltages.length; i++) {
                if (this.product.product != 'ROUNDF' || !this.round_voltage_exclusions.includes(this.voltages[i].label)) {
                    v.push(this.voltages[i]);
                }
            }
            //sort voltages by frequency, phase, then voltage
            function compare(a, b) {
                if (a.frequency < b.frequency) return 1;
                if (a.frequency > b.frequency) return -1;
                if (a.phase > b.phase) return 1;
                if (a.phase < b.phase) return -1;
                if (a.voltage == null) return -1;
                if (a.voltage > b.voltage) return 1;
                if (a.voltage < b.voltage) return -1;
                return 0;
            }
            v.sort(compare);

            return v;
        }
    },
    watch: {
        'product.product_id': function(nV) {
            var p = this.getProduct(nV);
            this.product.product = p.tutco_id;
            this.product.program = p.program;
            if (p.tutco_id == "ROUNDF") {
                this.product.diameter = 10;
                this.show_recess = false;
                this.product.insulation_thickness = null;
                //reset because items may not be available.
                this.product.voltage = {
                    voltage: null,
                    id: null,
                    frequency: null,
                    phase: null,
                    label: null
                };
            }
            if (this.product.product == 'EDH2' || this.product.product == 'EVH' || this.product.product == 'EDH') {
                this.product.control_voltage = 24;
            }
        },
        'product.quote_accessories': {
            deep: true,
            handler: function(newV) {
                if (newV[19] == 1) {
                    this.validate_stages();
                }
            }
        },
        'show_recess': function(nV) {
            if (!nV) {
                this.product.insulation_thickness = null;
            }
        }
    }
}

</script>
<style>
.duct-image {
    max-height: 250px;
    max-width: 100%;
}

</style>
